import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromHTML, ContentState } from "draft-js";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import { getApiUrl } from "../../utils/api";

const RichTextEditor = ({ initialValue, onEdit }) => {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    setEditorState(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(initialValue))
      )
    );
  }, [initialValue]);

  async function uploadInlineImageForArticle(file) {
    const formData = new FormData();
    formData.append("image", file);

    try {
      let { data } = await axios.post(getApiUrl("/files/single"), formData);
      return data;
    } catch (e) {
      console.log("caught error");
      console.error(e);
      return null;
    }
  }

  async function uploadImageCallBack2(file) {
    const imgData = await uploadInlineImageForArticle(file);
    return Promise.resolve(imgData);
  }

  function onEditorStateChange(editorState) {
    setEditorState(editorState);
    onEdit(editorState);
  }

  return (
    <div
      style={{
        border: "1px solid black",
        padding: "2px",
        minHeight: "400px",
      }}
    >
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        id="descricao"
        toolbar={{
          // options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
          options: [
            "inline",
            "list",
            "textAlign",
            "link",
            "embedded",
            "image",
            "remove",
            "history",
          ],
          image: {
            previewImage: true,
            uploadEnabled: true,
            urlEnabled: true,
            uploadCallback: uploadImageCallBack2,
            inputAccept: "image/gif,image/jpeg,image/jpg,image/png",
            alt: { present: true, mandatory: true },
          },
        }}
      />
    </div>
  );
};

export default RichTextEditor;
